import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchMissingRemittanceDetails(parameters, isEnabled) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "FetchMissingRemittanceDetails";

  async function FetchMissingRemittanceDetails() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get("api/MissingRemittances/GetAdminMissingRemittanceNotes", {
        params: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await FetchMissingRemittanceDetails(),
    enabled: isEnabled,
    refetchOnWindowFocus: false
  });
}
